// extracted by mini-css-extract-plugin
export default {"Text":"Text_Text__3CRT5","Small":"Text_Small__v-td3","Big":"Text_Big__Iiw3p"};